import {
  OPEN_PANEL,
  CLOSE_PANEL,
  SET_EXPANDED_ID,
  SET_PREVIEW_IMAGE,
  MARK_AS_READ,
  SET_ACTIVE_PREVIEW,
  CLEAR_ACTIVE_PREVIEW} from "./ai.actionTypes.js"

export const openPanel = () => ({ type: OPEN_PANEL });

export const closePanel = () => ({ type: CLOSE_PANEL });

export const setExpandedId = (id) => ({
  type: SET_EXPANDED_ID,
  payload: id,
});

export const setPreviewImage = (insightId, url) => ({
  type: SET_PREVIEW_IMAGE,
  payload: { insightId, url },
});

export const setActivePreview = (insightId) => ({
  type: SET_ACTIVE_PREVIEW,
  payload: insightId,
});

export const  clearActivePreview =()=>({
type: CLEAR_ACTIVE_PREVIEW
}
)
export const markAsRead = (id) => ({
  type: MARK_AS_READ,
  payload: id,
});
